<template>
  <div>
    <d-checkbox
      toggle
      v-model="enabled"
      class="custom-toggle-sm"
      @change="rebalancePercentages"
    >
      {{ resolvedCheckboxLabel }}
      <i
        id="tooltip-percentage-distribution"
        class="fas fa-info-circle text-muted"
        style="cursor: pointer"
      />
      <d-tooltip :target="'tooltip-percentage-distribution'" placement="top">
        {{ resolvedTooltipText }}
      </d-tooltip>
    </d-checkbox>

    <div v-if="enabled">
      <d-form-row class="d-flex flex-wrap">
        <d-col v-for="direction in Object.keys(enabledKeys)" :key="direction">
          <label class="form-control-label">
            {{ labels[direction] || direction }}
          </label>
          <d-input-group append="%">
            <d-form-input
              type="number"
              :min="0"
              :max="100"
              :placeholder="$t('shared.distribution.placeholder')"
              v-model.number="localDistribution[direction]"
            />
          </d-input-group>
        </d-col>
      </d-form-row>

      <p class="text-muted mt-2">
        {{ $t('shared.distribution.total') }} <strong>{{ total }}%</strong>
        <span v-if="total !== 100" class="text-danger">
          {{ $t('shared.distribution.mustSum100') }}</span
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'distribution-by-percentage',
  props: {
    value: {
      type: Object,
      required: true,
    },
    enabledByDefault: {
      type: Boolean,
      default: false,
      required: true,
    },
    checkboxLabel: {
      type: String,
      default: null,
    },
    tooltipText: {
      type: String,
      default: null,
    },
    enabledKeys: {
      type: Object,
      required: true,
    },
    labels: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localDistribution: { ...this.value },
    };
  },
  computed: {
    enabled: {
      get() {
        return this.enabledByDefault;
      },
      set(val) {
        this.$emit('update:enabledByDefault', val);
      },
    },
    total() {
      return Object.values(this.localDistribution).reduce(
        (sum, val) => sum + val,
        0,
      );
    },
    resolvedCheckboxLabel() {
      return this.checkboxLabel || this.$t('shared.distribution.checkboxLabel');
    },
    resolvedTooltipText() {
      return this.tooltipText || this.$t('shared.distribution.tooltip');
    },
  },
  watch: {
    enabledKeys: {
      deep: true,
      handler() {
        if (this.enabled) this.rebalancePercentages();
      },
    },
    localDistribution: {
      deep: true,
      handler(newVal) {
        this.$emit('input', newVal);
        if (this.total === 100) {
          this.$emit('change', newVal);
        }
      },
    },
  },
  methods: {
    rebalancePercentages() {
      const keysToDistribute = Object.keys(this.enabledKeys);
      const count = keysToDistribute.length;

      if (count === 0) return;

      const base = Math.floor(100 / count);
      const remainder = 100 - base * count;

      const newPercentages = {};

      keysToDistribute.forEach((key, index) => {
        newPercentages[key] = base + (index === count - 1 ? remainder : 0);
      });

      this.localDistribution = newPercentages;
    },
  },
};
</script>
